import icon from './franceconnect.svg';

import type { Provider } from '../providers'

export default {
    key: 'franceconnect',
    name: 'France Connect',
    color: '#034ea2',
    icon
} satisfies Provider;
